import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import supermanIcon from "APP_ASSETS/images/superman_s_symbol.svg";
import { SATL } from "MODULES/parts/constants";

const TierTypeIcon = ({
  part,
  keepWhiteSpace,
  size,
  position,
  inline,
  tier_type_key
}) => {
  const hasIcon = [SATL].includes(part[tier_type_key]);

  const inlineClassName = classNames({ "align-middle": !inline });
  const className = classNames("tier-type-icon", inlineClassName, {
    "tier-type-icon--small": size === "small",
    "tier-type-icon--left": position === "left",
    "tier-type-icon--right": position === "right"
  });

  if (!keepWhiteSpace && !hasIcon) {
    return null;
  }

  return (
    <div className={className}>
      {part[tier_type_key] === SATL && (
        <img src={supermanIcon} alt={SATL} className={inlineClassName} />
      )}
    </div>
  );
};

TierTypeIcon.propTypes = {
  part: PropTypes.shape({
    id: PropTypes.number.isRequired,
    part_number: PropTypes.string.isRequired
  }).isRequired,
  keepWhiteSpace: PropTypes.bool,
  inline: PropTypes.bool,
  tier_type_key: PropTypes.string,
  size: PropTypes.oneOf(["small", "normal"]),
  position: PropTypes.oneOf(["left", "right"])
};

TierTypeIcon.defaultProps = {
  keepWhiteSpace: true,
  inline: false,
  size: "normal",
  position: "left",
  tier_type_key: "tier_type"
};

export default TierTypeIcon;



// WEBPACK FOOTER //
// ./app/modules/shared/components/TierTypeIcon/TierTypeIcon.jsx